import { BannerRepository } from '../../../domain/repositories/banner.repository';
import { BannerSettingsEntity } from '../../../domain/entities/banner-settings.entity';

export class GetBannerSettingsUseCase {
  constructor(private readonly bannerRepository: BannerRepository) {}

  public async execute(): Promise<BannerSettingsEntity> {
    if (this.bannerRepository.getSettings) {
      return this.bannerRepository.getSettings();
    }
    return new BannerSettingsEntity();
  }
}
